/**
 * Service: passesAttributes
 */
angular.module('acme.common.service.passesAttributes', [
  'acme.common.service.calendar'
])
.service('PassesAttributesService', ['CalendarService', function(CalendarService) {

    return {

      model: {
        maxUses: 1,
        maxQuantity: 1,
        startDate: CalendarService.toISO8601(new Date()),
        endDate: CalendarService.toISO8601(new Date())
      },

      init: function() {
        return true;
      },

      resetModel: function() {
        this.model = {
          maxUses: 1,
          maxQuantity: 1,
          startDate: CalendarService.toISO8601(new Date()),
          endDate: CalendarService.toISO8601(new Date())
        };
      },

      setModel: function(model) {
        this.model = model;
      },

      getModel: function() {
        return this.model;
      }

    };

}]);